import { themeShadows } from "./themeColors";

export const components = {
  MuiTableContainer: {
    styleOverrides: {
      root: {
        boxShadow: themeShadows[2],
        borderRadius: "8px",
        border: "1px solid #ddd",
        backgroundColor: "#fff",
        padding: 0, // no padding for max space
        maxWidth: "100%",
        maxHeight: "calc(100vh - 163px)",
        overflowY: "auto",
        overflowX: "auto",
      },
    },
  },

  MuiTable: {
    styleOverrides: {
      root: {
        tableLayout: "fixed",
        borderCollapse: "collapse",
        width: "100%",
        backgroundColor: "#fff",
      },
    },
  },

  MuiTableRow: {
    styleOverrides: {
      root: {
        transition: "background-color 0.15s ease-in-out",
        "&:hover": {
          backgroundColor: "#f3f8ff", // very subtle hover
          boxShadow: "none", // avoid extra shadow for cleanliness
        },
      },
    },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        minHeight: '36px',          // reduce default min height
        paddingTop: '4px',
        paddingBottom: '4px',
        '& .MuiButton-root': {
          minHeight: '30px',        // smaller buttons inside toolbar
          padding: '4px 8px',
          fontSize: '10px',
        },
        '& .MuiIconButton-root': {
          padding: '4px',           // smaller icon buttons (top right icons)
        },
      },
    },
  },

  MuiTablePagination: {
    styleOverrides: {
      root: {
        minHeight: '36px',          // reduce pagination height
      },
      toolbar: {
        paddingLeft: '8px',
        paddingRight: '8px',
        minHeight: '36px',
        '& .MuiSelect-select': {
          paddingTop: '4px',
          paddingBottom: '4px',
        },
        '& .MuiTablePagination-actions': {
          marginTop: 0,
          marginBottom: 0,
        },
      },
      selectLabel: {
        fontSize: '10px',
      },
      displayedRows: {
        fontSize: '10px',
      },
    },
  },

  MuiTableCell: {
    styleOverrides: {
      head: {
        fontSize: "11px",
        fontWeight: 700,
        textTransform: "uppercase",
        padding: "4px 8px", // reduced padding
        backgroundColor: "#f0f4fb",
        color: "#1a237e",
        borderBottom: "1px solid #ccc",
        borderRight: "1px solid #e0e0e0",
        whiteSpace: "nowrap", // prevent wrapping
        position: "sticky",       // Make header sticky
        top: 0,                  // Stick to the top
        zIndex: 10,              // Ensure header is above rows
        lineHeight: 1.3,
        letterSpacing: "0.3px",
        "&:last-child": {
          borderRight: "none",
        },
      },
      root: {
        fontSize: "11px",
        padding: "4px 8px", // tighter padding
        color: "#222",
        borderBottom: "1px solid #f5f5f5",
        borderRight: "1px solid #f5f5f5",
        maxWidth: "160px", // tighter width for many columns
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        backgroundColor: "#fff",
        "&:nth-of-type(even)": {
          backgroundColor: "#fcfcfc",
        },
        "&:last-child": {
          borderRight: "none",
        },
      },
    },
  },

  MuiTablePagination: {
    styleOverrides: {
      toolbar: {
        paddingLeft: "8px", // tighter padding
        paddingRight: "8px",
        minHeight: "36px", // smaller height
      },
      selectLabel: {
        fontSize: "10px",
      },
      displayedRows: {
        fontSize: "10px",
      },
    },
  },

  MuiTableSortLabel: {
    styleOverrides: {
      root: {
        fontWeight: 700,
        fontSize: "11px",
        "& svg": {
          marginLeft: "2px",
          fontSize: "14px",
          color: "#90a4ae",
        },
        "&.Mui-active svg": {
          color: "#1976d2",
        },
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        padding: "4px", // reduce padding to keep it tight
        '& svg': {
          fontSize: '16px', // reduce the checkbox icon size
        },
      },
    },
  },

  MuiButton: {
    styleOverrides: {
      root: {
        fontSize: "10px",
        borderRadius: "6px",
        textTransform: "none",
        padding: "2px 8px", // smaller padding
        fontWeight: 500,
        boxShadow: "none",
        minWidth: "auto",
        lineHeight: 1,
      },
      containedPrimary: {
        backgroundColor: "#2979ff",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#1565c0",
        },
      },
      containedWarning: {
        backgroundColor: "#ffa000",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#ef6c00",
        },
      },
    },
  },

MuiChip: {
  styleOverrides: {
    root: {
      fontSize: "9px",
      fontWeight: 600,
      borderRadius: "8px",
      height: "20px",
      padding: "0 6px",
      textTransform: "capitalize",

      "& .MuiChip-label": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        paddingLeft: 6,
        paddingRight: 6,
        lineHeight: "20px",
      },
    },

    colorPrimary: {
      backgroundColor: "#e3f2fd",
      color: "#1565c0",
    },

    colorSuccess: {
      backgroundColor: "#e8f5e9",
      color: "#2e7d32",
    },

    colorWarning: {
      backgroundColor: "#fff3e0",
      color: "#ef6c00",
    },
  },
},
};

